import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

export function CancelDeferredDialog(props: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Отмена отложенного остатка</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Неопубликованный остаток расписания выполнен не будет. Уже опубликованные элементы сохранятся.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Назад</Button>
        <Button onClick={props.onConfirm} color="warning" variant="contained">
          Отменить остаток
        </Button>
      </DialogActions>
    </Dialog>
  );
}
